import axios from 'axios';
import { getApiRoot } from '../../constants/ParamountReactConstants';

export function regenerateAiCustomField({
  customFieldId,
  itemIds,
  filterId,
  withoutItemIds,
}: {
  customFieldId: number;
  itemIds?: number[];
  filterId?: number;
  withoutItemIds?: number[];
}) {
  return {
    type: 'REGENERATE_AI_CUSTOM_FIELD',
    payload: axios.post(`${getApiRoot()}/ai_custom_fields/regenerate`, {
      custom_field_id: customFieldId,
      item_ids: itemIds,
      filter_id: filterId,
      without_item_ids: withoutItemIds,
    }),
  };
}
